import { Button } from '@zorro/design-system/v2/Button';
import { ActionDialogProps } from '@zorro/design-system/v2/Dialog';
import { Group, Text } from '@zorro/web/design-system';

import { AppLayoutMenuPage } from './AppLayoutMenuPage';

type Props = Pick<
  ActionDialogProps,
  | 'isOpen'
  | 'onClose'
  | 'title'
  | 'description'
  | 'children'
  | 'primaryLabel'
  | 'onPrimaryAction'
  | 'isPrimaryLoading'
  | 'isPrimaryDisabled'
  | 'secondaryLabel'
  | 'onSecondaryAction'
  | 'backLabel'
  | 'onBack'
>;

export const AppLayoutMenuActionPage = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  primaryLabel = 'Confirm',
  onPrimaryAction,
  isPrimaryLoading,
  isPrimaryDisabled,
  secondaryLabel = 'Cancel',
  onSecondaryAction,
  backLabel = 'Back',
  onBack,
}: Props) => {
  if (!isOpen) {
    return null;
  }

  return (
    <AppLayoutMenuPage
      title={title}
      onClose={onClose}
      onBack={backLabel ? onBack : undefined}
      footer={
        <Group gap="var(--space-12)" wrap="nowrap">
          {secondaryLabel && (
            <Button
              variant="tertiary"
              size="lg"
              flex={1}
              onClick={onSecondaryAction}
            >
              {secondaryLabel}
            </Button>
          )}
          <Button
            variant="primary"
            size="lg"
            flex={1}
            onClick={onPrimaryAction}
            loading={isPrimaryLoading}
            disabled={isPrimaryDisabled}
          >
            {primaryLabel}
          </Button>
        </Group>
      }
    >
      {description && (
        <Text
          fz="var(--font-size-14)"
          lh="var(--font-line-height-22)"
          lts="var(--font-letter-spacing-negative-0-2)"
          c="var(--color-text-default-primary)"
        >
          {description}
        </Text>
      )}
      {children}
    </AppLayoutMenuPage>
  );
};
